import { Home as HomeIcon } from '@mui/icons-material';
import { Button, Paper, Stack, Typography } from '@mui/material';
import { Layout } from 'components';
import { useNavigate } from 'react-router-dom';

const Forbidden = () => {
  const navigate = useNavigate();

  return (
    <Layout>
      <Paper
        elevation={0}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: 'calc(100vh - 100px)',
          p: 4,
          backgroundColor: 'transparent',
        }}
      >
        <Stack spacing={3} alignItems="center">
          <Typography
            variant="h1"
            sx={{
              fontSize: '120px',
              fontWeight: 700,
              color: 'primary.main',
              lineHeight: 1,
            }}
          >
            403
          </Typography>
          <Typography
            variant="h4"
            sx={{
              fontSize: '24px',
              fontWeight: 600,
              color: 'grey1.light',
              textAlign: 'center',
            }}
          >
            Access Forbidden
          </Typography>
          <Typography
            variant="body1"
            sx={{
              fontSize: '16px',
              color: '#666666',
              textAlign: 'center',
              maxWidth: '500px',
            }}
          >
            You don't have permission to access this page. Please contact the
            administrator if you need access.
          </Typography>
          <Button
            variant="contained"
            startIcon={<HomeIcon />}
            onClick={() => navigate('/')}
            sx={{
              mt: 2,
              px: 4,
              py: 1.5,
            }}
          >
            Go to Home
          </Button>
        </Stack>
      </Paper>
    </Layout>
  );
};

export default Forbidden;
